import { IdAssetBundleCalloutIcons } from "../assetBundles/IdAssetBundleCalloutIcons";
import { utilGrid } from "../utils/grid/utilGrid";
import { BF2CreateAsset } from "./BF2BuildingGraphicsUtils";
var Container = PIXI.Container;
export var BF2GetExpansionCalloutsIso = function (data, isDiscount) {
    var container = new Container();
    var config = {
        id: isDiscount
            ? IdAssetBundleCalloutIcons.ExpansionSaleIcn
            : IdAssetBundleCalloutIcons.ExpandFarmIcn,
    };
    var sprite = BF2CreateAsset(config);
    if (sprite) {
        container.addChild(sprite);
        var objectPos = utilGrid.objectHoverOnMap(data);
        var pos = utilGrid.mapToScreen(objectPos.x, objectPos.y);
        container.position.set(pos.x, pos.y);
    }
    return container;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/BF2GetExpansionCalloutsIso.ts
// module id = 2221
// module chunks = 3